const ROBOTO = "font-['Roboto']"

export const getSectionHeaderClass = (getDarkModeClasses) =>
  `${ROBOTO} text-xl font-medium leading-7 ${getDarkModeClasses('text-[#2f2f2f]', 'text-gray-200')}`

export const getSelectClass = (getDarkModeClasses) =>
  `h-10 w-full appearance-none rounded-lg border px-[13px] ${ROBOTO} text-base font-medium focus:outline-none focus:ring-2 ${getDarkModeClasses(
    'border-[#cbd5e0] bg-[#f7fafc] text-[#2f2f2f] focus:ring-[#1e7129]/20',
    'border-gray-600 bg-gray-700 text-white focus:ring-green-500/20',
  )}`

export const getSelectLabelClass = (getDarkModeClasses) =>
  `mb-1 block ${ROBOTO} text-base font-medium ${getDarkModeClasses('text-[#2f2f2f]', 'text-gray-200')}`

export const getWaitingRoomCardClass = (getDarkModeClasses) =>
  `flex min-h-0 flex-col overflow-hidden rounded-[10px] border p-[17px] ${getDarkModeClasses(
    'border-[#cbd5e0] bg-[#f7fafc]',
    'border-gray-600 bg-gray-800',
  )}`

export const getWaitingRoomCardHeadingClass = (getDarkModeClasses) =>
  `mb-3 flex-shrink-0 ${ROBOTO} text-lg font-medium ${getDarkModeClasses('text-[#2f2f2f]', 'text-gray-200')}`

export const getListRowClass = (getDarkModeClasses) =>
  `flex min-h-12 items-center justify-between rounded-[10px] px-3 py-2 ${getDarkModeClasses('bg-white', 'bg-gray-700')}`

export const getIdleColumnLeftClass = (getDarkModeClasses) =>
  `flex h-full min-h-0 flex-col overflow-hidden border-r p-8 ${getDarkModeClasses(
    'border-[#e5e7eb] bg-white',
    'border-gray-600 bg-gray-800',
  )}`

export const getIdleColumnMiddleClass = (getDarkModeClasses) =>
  `flex h-full min-h-0 flex-col overflow-hidden border-r p-8 ${getDarkModeClasses(
    'border-[#e5e7eb] bg-[#f3f4f6]',
    'border-gray-600 bg-gray-900',
  )}`

export const getIdleColumnRightClass = (getDarkModeClasses) =>
  `flex h-full min-h-0 flex-col overflow-hidden p-8 ${getDarkModeClasses(
    'bg-white',
    'bg-gray-800',
  )}`

export const getStatusBannerStyles = (availability, getDarkModeClasses) => {
  if (availability === 'text_only') {
    return {
      container: getDarkModeClasses(
        'border-2 border-[#fdc700] bg-[#fefce8]',
        'border-2 border-yellow-600 bg-yellow-900/30',
      ),
      value: getDarkModeClasses('text-[#a65f00]', 'text-yellow-300'),
      label: getDarkModeClasses('text-[#2f2f2f]/70', 'text-gray-400'),
    }
  }

  if (availability === 'audio_video') {
    return {
      container: getDarkModeClasses(
        'border-2 border-[#1e7129] bg-[#e9f2e2]',
        'border-2 border-green-700 bg-green-900/30',
      ),
      value: getDarkModeClasses('text-[#1e7129]', 'text-green-400'),
      label: getDarkModeClasses('text-[#2f2f2f]/70', 'text-gray-400'),
    }
  }

  return {
    container: getDarkModeClasses(
      'border-2 border-[#cbd5e0] bg-[#f3f4f6]',
      'border-2 border-gray-600 bg-gray-700/50',
    ),
    value: getDarkModeClasses('text-[#6a7282]', 'text-gray-400'),
    label: getDarkModeClasses('text-[#2f2f2f]/70', 'text-gray-500'),
  }
}

export const getWaitingTitleClass = (isUnavailable, getDarkModeClasses) =>
  isUnavailable
    ? getDarkModeClasses('text-[#6a7282]', 'text-gray-400')
    : getDarkModeClasses('text-[#1e7129]', 'text-green-400')

export const getCandidateStatusClass = (getDarkModeClasses) =>
  `${ROBOTO} text-sm font-normal ${getDarkModeClasses('text-[#08467c]', 'text-blue-400')}`

export const getProfileLinkClass = (getDarkModeClasses) =>
  `${ROBOTO} text-sm font-normal no-underline hover:underline ${getDarkModeClasses('text-[#08467c]', 'text-blue-400')}`

export const getUnderlinedLinkClass = (getDarkModeClasses) =>
  `underline hover:opacity-90 ${getDarkModeClasses('text-[#08467c]', 'text-blue-400')}`

export const getPersonNameClass = (getDarkModeClasses) =>
  `truncate ${ROBOTO} text-base font-normal ${getDarkModeClasses('text-[#2f2f2f]', 'text-gray-200')}`

export const getEmptyStateTextClass = (getDarkModeClasses) =>
  `text-center ${ROBOTO} text-base font-medium ${getDarkModeClasses('text-[#6a7282]', 'text-gray-400')}`

export const getEmptyStateIconClass = (getDarkModeClasses) =>
  `h-10 w-10 ${getDarkModeClasses('text-[#6a7282]', 'text-gray-500')}`

export const getCoachBadgeClass = (status, getDarkModeClasses) => {
  if (status === 'busy') {
    return getDarkModeClasses(
      "rounded-lg bg-[#e9f2e2] px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-[#1c6f29]",
      "rounded-lg bg-green-900/40 px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-green-300",
    )
  }

  if (status === 'away') {
    return getDarkModeClasses(
      "rounded-lg bg-[#f3f4f6] px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-[#6a7282]",
      "rounded-lg bg-gray-700 px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-gray-400",
    )
  }

  return getDarkModeClasses(
    "rounded-lg bg-[#1c6f29] px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-white",
    "rounded-lg bg-green-800 px-[9px] py-[3px] font-['Roboto'] text-xs font-medium text-green-100",
  )
}

export const getDarkModeLabelClass = (getDarkModeClasses) =>
  `${ROBOTO} text-base font-medium ${getDarkModeClasses('text-[#2f2f2f]', 'text-gray-300')}`
